module.exports = __webpack_public_path__ + "static/media/S_F03.0903e16c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BLUE/S_F03.png
// module id = 82
// module chunks = 0